<!-- 企业设置 -->
<template>
  <div class="enterprise-set-main">
    <!-- 容量管理 -->
    <!-- <el-button @click="handleOpen">跳转</el-button> -->
    <div class="option-li">
      <div class="option-top">
        <div class="options-title">
          <img class="icon-style" src="@/assets/img/bingding_icon.png" alt="" />
          <div class="title-text">
            <div class="flex">
              容量管理
              <el-progress
                :percentage="capacityData.percentage"
                color="rgb(128,128,255)"
                stroke-linecap="butt"
                :stroke-width="8"
                :format="formatCapacity"
                class="capacity"
              ></el-progress>
              <span class="capacity-text"
                >{{ capacityData.hasUse }}/{{ capacityData.total }}</span
              >
            </div>
          </div>
          <div class="option-btn" @click="option(3)">
            <span>{{ !optionType3 ? "展开" : "收起" }}</span>
            <i
              class="btn-icon el-icon-caret-bottom"
              :class="optionType3 ? 'btn-icon2' : ''"
            ></i>
          </div>
        </div>
        <div class="options-explain">
          <span class="explan-text"
            >当空间容量不足，请立即联系客莱宝平台人员续费扩容。</span
          >
        </div>
      </div>
      <div
        class="option-bottom"
        :class="optionType3 ? 'option-bottom-open3' : 'option-bottom-close'"
      >
        <div
          class="flex capacity-item"
          v-for="(item, index) in capacityData.items"
          :key="index"
        >
          <span class="capacity-item-point"></span>
          <div class="capacity-item-label">{{ item.label }}</div>
          <div class="capacity-item-detail">已使用{{ item.value }}</div>
        </div>
      </div>
    </div>
    <!-- 绑定/解绑 -->
    <div class="option-li">
      <div class="option-top">
        <div class="options-title">
          <img class="icon-style" src="@/assets/img/bingding_icon.png" alt="" />
          <div class="title-text">绑定/解绑档案审批</div>
          <div
            class="option-btn"
            :class="aprroveOpenStatus ? '' : 'disable-open'"
            @click="option(1)"
          >
            <span>{{ !optionType ? "展开" : "收起" }}</span>
            <i
              class="btn-icon el-icon-caret-bottom"
              :class="optionType ? 'btn-icon2' : ''"
            ></i>
          </div>
        </div>
        <div class="options-explain">
          <span class="explan-text"
            >如果员工出现随意绑定或解绑客户档案情况，您可以选择开启此审批。开启后作用于全企业。</span
          >
          <!-- <img  src="@/assets/img/tip.png" class="tip-icon" alt="" /> -->
          <!-- <span class="explan-text-tip">开启后请按照说明配置审批人。</span> -->
          <!-- <span class="explain-btn">说明...</span> -->
        </div>
      </div>
      <div
        class="option-bottom"
        :class="optionType ? 'option-bottom-open' : 'option-bottom-close'"
      >
        <el-checkbox-group @change="checkChange" v-model="checkList">
          <div
            class="check-item"
            :class="checkList.includes('approveBindStatus') ? 'is-check' : ''"
          >
            <el-checkbox label="approveBindStatus">
              <div class="check-label-wrap">
                <span class="label-title">绑定档案需要通过审批</span>
                <span class="label-tip"
                  >当客户已绑定1份档案之后的绑定均需要审批</span
                >
              </div>
            </el-checkbox>
          </div>
          <div
            class="check-item"
            :class="checkList.includes('approveUnBindStatus') ? 'is-check' : ''"
          >
            <el-checkbox label="approveUnBindStatus">
              <div class="check-label-wrap">
                <span class="label-title">解绑档案需要通过审批</span>
                <span class="label-tip">所有解绑均需要审批</span>
              </div>
            </el-checkbox>
          </div>
        </el-checkbox-group>
        <div class="btn-wrap">
          <el-button plain :disabled="approveDisable" @click="approveCancel"
            >取消</el-button
          >
          <el-button
            type="primary"
            :disabled="approveDisable"
            @click="approveSave"
            >保存</el-button
          >
        </div>
      </div>
    </div>
    <!-- 标签同步 -->
    <div class="option-li">
      <div class="option-top">
        <div class="options-title">
          <img class="icon-style" src="@/assets/img/bingding_icon.png" alt="" />
          <div class="title-text">标签同步</div>
          <div class="option-btn" @click="option(5)">
            <span>{{ !optionType5 ? "展开" : "收起" }}</span>
            <i
              class="btn-icon el-icon-caret-bottom"
              :class="optionType5 ? 'btn-icon2' : ''"
            ></i>
          </div>
        </div>
        <div class="options-explain">
          <span class="explan-text"
            >将宏脉系统标签和企微标签基础数据双向同步，达到标签统一的效果。</span
          >
        </div>
      </div>
      <div
        class="option-bottom"
        :class="optionType5 ? 'option-bottom-open' : 'option-bottom-close'"
      >
        <!-- 遮罩层，用于禁用按钮点击后点击触发提示 -->
        <div
          class="mask"
          :class="isClick ? 'maskShow' : ''"
          @click="tipClick"
        ></div>
        <el-button
          size="small"
          class="synchronization-btn"
          type="primary"
          @click="synchronization"
          :disabled="isClick"
          >客户标签同步</el-button
        >
      </div>
    </div>
    <!-- 删除好友预警 -->
    <div class="option-li">
      <div class="option-top">
        <div class="options-title">
          <img class="icon-style" src="@/assets/img/bingding_icon.png" alt="" />
          <div class="title-text">删除好友预警</div>
          <div class="option-btn" @click="option(6)">
            <span>{{ !optionType6 ? "展开" : "收起" }}</span>
            <i
              class="btn-icon el-icon-caret-bottom"
              :class="optionType6 ? 'btn-icon2' : ''"
            ></i>
          </div>
        </div>
        <div
          class="option-bottom"
          :class="optionType6 ? 'option-bottom-open' : 'option-bottom-close'"
        >
          <div class="notification-column">
            <div class="operation-wrap" @click="getEmployee">
              <span class="explan-text">通知职员 </span>
              <el-input
                v-model="selectedEmployeeNum"
                style="width: 240px"
                size="small"
                placeholder="请选择"
                readonly
              />
            </div>
            <!-- <div class="notification-btn">
              <el-button size="small" type="info" @click="cancel"
                >取消</el-button
              >
              <el-button size="small" type="primary" @click="save"
                >保存</el-button
              >
            </div> -->
          </div>
          <div class="tag-wrap" v-if="!!searchMenNames.length">
            <el-tag
              class="el-tag-class"
              v-for="tag in searchMenNames"
              :key="tag.userId"
              type="primary"
              size="small"
            >
              {{ tag.name }}
            </el-tag>
          </div>
          <div class="btn-wrap">
            <el-button plain @click="cancel" :disabled="!searchMenNames.length"
              >取消</el-button
            >
            <el-button type="primary" @click="save">保存</el-button>
          </div>
        </div>
      </div>
      <!-- <div
        class="option-bottom"
        :class="optionType5 ? 'option-bottom-open' : 'option-bottom-close'"
      >
        <div
          class="mask"
          :class="isClick ? 'maskShow' : ''"
          @click="tipClick"
        ></div>
        <el-button
          size="small"
          class="synchronization-btn"
          type="primary"
          @click="synchronization"
          :disabled="isClick"
          >客户标签同步</el-button
        >
      </div> -->
    </div>
    <!-- 业绩推送消息设置 -->
    <!-- <div class="option-li">
      <div class="option-top">
        <div class="options-title">
          <img class="icon-style" src="@/assets/img/bingding_icon.png" alt="" />
          <div class="title-text">业绩推送消息设置</div>
          <div
            class="option-btn"
            :class="aprroveOpenStatus ? '' : 'disable-open'"
            @click="option(2)"
          >
            <span>{{ !optionType2 ? "展开" : "收起" }}</span>
            <i
              class="btn-icon el-icon-caret-bottom"
              :class="optionType2 ? 'btn-icon2' : ''"
            ></i>
          </div>
        </div>
      </div>
      <div
        class="option-bottom"
        :class="optionType2 ? 'option-bottom-open' : 'option-bottom-close'"
      >
        <div class="check-item">
          <div class="check-label-wrap">
            <span class="label-title">是否发送:</span
            ><el-switch v-model="delFlag"> </el-switch>
          </div>
        </div>
        <div
          class="check-item"
          :class="checkList.includes('approveBindStatus') ? 'is-check' : ''"
        >
          <div class="check-label-wrap">
            <span class="label-title">接收人:</span>
            <el-button size="small" type="info" @click="handleSelect"
              >请选择人员</el-button
            >
          </div>
          <el-tag
            v-for="tag in searchMenNames"
            :key="tag.name"
            closable
            style="margin: 5px"
            @close="handleClose(tag)"
          >
            {{ tag.name }}
          </el-tag>
        </div>
        <div
          class="check-item"
          :class="checkList.includes('approveUnBindStatus') ? 'is-check' : ''"
        >
          <div class="check-label-wrap">
            <span class="label-title">发送时间：</span>
            <span class="label-tip" style="color: #8a8a8a"
              >每天
              <el-time-picker
                v-model="sendTime"
                placeholder="任意时间点"
                format="HH:mm"
                value-format="yyyy-MM-DD HH:mm:ss"
                size="small"
                style="width: 160px"
                @change="timeChange"
              ></el-time-picker>
            </span>
          </div>
        </div>
        <div class="btn-wrap">
          <el-button plain :disabled="sendTime == null" @click="sendCancel"
            >取消</el-button
          >
          <el-button type="primary" @click="sendSave">保存</el-button>
        </div>
      </div>
    </div> -->

    <!-- 潜在需求设置 -->
    <!-- <div class="option-li">
      <div class="option-top">
        <div class="options-title">
          <img class="icon-style" src="@/assets/img/bingding_icon.png" alt="" />
          <div class="title-text">潜在需求设置</div>
          <div
            class="option-btn"
            :class="aprroveOpenStatus ? '' : 'disable-open'"
            @click="option(4)"
          >
            <span>{{ !optionType ? "展开" : "收起" }}</span>
            <i
              class="btn-icon el-icon-caret-bottom"
              :class="optionType ? 'btn-icon2' : ''"
            ></i>
          </div>
        </div>
      </div>
      <div
        class="option-bottom"
        :class="optionType4 ? 'option-bottom-open' : 'option-bottom-close'"
      >
          <div
            class="check-item"
          >
            <span style="margin-right: 20px; font-weight: bold"
              >侧边栏潜在需求显示主键</span
            >
            <el-radio-group v-model="pType">
            <el-radio label="1">检查项目</el-radio>
            <el-radio label="2">咨询项目</el-radio>
            <el-radio label="3">潜在项目</el-radio>
          </el-radio-group>
          </div>
        <div class="btn-wrap">
          <el-button plain @click="getPtypes">取消</el-button>
          <el-button type="primary" @click="savePtypes">保存</el-button>
        </div>
      </div>
    </div> -->
    <div class="option-li">
      <el-button @click="handleDownload">企微多开工具下载页面</el-button>
    </div>
    <StaffTree
      title="选择成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      ref="myStaffTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
  </div>
</template>

<script>
import {
  getQySetting,
  updateQYApprove,
  transferAdmin,
  getDownLoad,
  reportSave,
  getReport,
  getPtype,
  savePtype,
  tagSyncTagApi,
  checkTimeApi,
  addStaffApi,
  messageStaffListApi,
} from "@/api/enterpriseSetting/enterpriseSetting.js";
import StaffTree from "@/components/staffTree/staffTree.vue";
import { Link, Message } from "element-ui";
import { getCheckSystemApi } from "@/api/index.js";
import { getOrganization } from "@/api/staffTree/staffTree.js";
export default {
  data() {
    return {
      optionType: false, // 绑定/解绑 展开与否，true为展开
      optionType3: false, // 容量管理 展开与否， true为展开
      optionType2: false, //业绩推送消息设置
      optionType4: false, //潜在需求设置
      optionType5: false, //同步标签设置
      optionType6: false, //删除好友预警设置
      delFlag: false, //是否发送
      dialogVisibleTree: false,
      searchMenNames: [],
      currentSelectMember: [],
      sendTime: null, //发送时间
      checkList: [], // 解绑/绑定选中值
      approveParams: {},
      initCheckList: [], // 解绑、绑定初始选中的值
      approveDisable: true, // 解绑/绑定 取消、保存按钮能不能选中
      aprroveOpenStatus: false,
      capacityData: {
        // 容量管理
        hasUse: "0MB",
        total: "0MB",
        items: [
          { label: "会话存档", value: "0M" },
          { label: "素材库", value: "0M" },
        ],
        percentage: 0,
      },
      pType: "1", //潜在需求设置  1 检查项目  2 咨询项目  3 潜在项目
      /** 判断同步按钮是否可点击 false为可以点击，true为不能点击*/
      isClick: false,
      /** 当前系统 0经典;  1云医美1.0； 2云医美4.0； 3客云 */
      // currentSysm: 0,
      /** 选中的员工人数 */
      selectedEmployeeNum: "",
      userList: [],
      allStaff: [],
      selectAllValue: [],
      treeData: [],
    };
  },

  components: {
    StaffTree,
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "基础管理" || item.pname == "企业设置") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("bdjbdasp") != -1) {
                // 可操作绑定解绑
                this.aprroveOpenStatus = true;
              } else {
                this.aprroveOpenStatus = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getPtypes() {
      getPtype(localStorage.getItem("Authorization")).then((res) => {
        this.pType = res.data.pType + "";
      });
    },
    savePtypes() {
      savePtype(localStorage.getItem("Authorization"), {
        projectType: this.pType,
        projectName:
          this.pType == 1
            ? "检查项目"
            : this.pType == 2
            ? "咨询项目"
            : "潜在项目",
      }).then((res) => {
        Message.success(res.error.message);
      });
    },

    handleSelect() {
      this.dialogVisibleTree = true;
    },
    handleDownload() {
      this.download(
        "/api/qywechat/tools/download",
        `WXPprocess.exe`,
        {},
        localStorage.getItem("Authorization"),
        "",
        "get"
      );
    },
    //展开/收起 type=1时操作的是绑定/解绑；
    option(type) {
      if (type == 1) {
        // 解绑/绑定 展开或收起
        if (this.aprroveOpenStatus) {
          this.optionType = !this.optionType;
        }
      } else if (type == 3) {
        this.optionType3 = !this.optionType3;
      } else if (type == 2) {
        this.optionType2 = !this.optionType2;
      } else if (type == 4) {
        this.optionType4 = !this.optionType4;
      } else if (type == 5) {
        this.optionType5 = !this.optionType5;
      } else if (type == 6) {
        this.optionType6 = !this.optionType6;
      }
    },
    checkChange(val) {
      this.approveDisable = false;
    },
    timeChange(e) {
      console.log("e", e);
    },
    // 审批设置取消
    approveCancel() {
      this.checkList = JSON.parse(JSON.stringify(this.initCheckList));
      this.approveDisable = true;
    },
    // 业绩推送消息设置
    sendCancel() {
      this.searchMenNames = [];
      this.sendTime = null;
    },
    sendSave() {
      reportSave(localStorage.getItem("Authorization"), {
        delFlag: this.delFlag ? 1 : 0,
        sendTime: this.sendTime,
        hmcStaffReport: this.searchMenNames,
      })
        .then((res) => {
          Message.success(res.error.message);
          this.getReports();
          // console.log("res", res);
        })
        .catch((err) => {
          Message.error(err.error.message);
        });
    },
    getReports() {
      getReport(localStorage.getItem("Authorization")).then((res) => {
        this.delFlag = res.data.delFlag == 1 ? true : false;
        this.sendTime = res.data.sendTime;
        this.searchMenNames = res.data.hmcStaffReport;
        this.currentSelectMember = res.data.hmcStaffReport;
      });
    },
    selectPerson() {
      this.$nextTick(() => {
        this.$refs.customerContact.show();
      });
    },
    handleClose(tag) {
      this.searchMenNames = this.searchMenNames.filter(
        (item) => item.userId != tag.userId
      );
      this.currentSelectMember = this.searchMenNames;
    },

    // end
    // 审批设置保存
    approveSave() {
      let arr = ["approveBindStatus", "approveUnBindStatus"];
      arr.forEach((val) => {
        if (this.checkList.includes(val)) {
          this.approveParams[val] = true;
        } else {
          this.approveParams[val] = false;
        }
      });
      updateQYApprove(
        this.approveParams,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 200) {
          this.$message.success("设置企业审批成功！");
          this.initCheckList = JSON.parse(JSON.stringify(this.checkList));
          this.approveDisable = true;
        } else {
          this.$message.error("设置企业审批失败,请重试！");
        }
      });
    },
    // 获取基础设置
    getQySetting() {
      getQySetting(localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          // 初始化绑定、解绑选中状态
          for (let key in res.data.approve) {
            if (res.data.approve[key]) {
              this.checkList.push(key);
            }
          }
          //   "chatCapacity": {    //容量管理
          //     "capacityTotal": 200GB    //总容量
          //     "activeCapacity": 80.5MB,    //总的已使用容量
          //     "chatCapacity": 40.4MB,    //会话存档已使用容量
          //     "materialCapacity": 40.1MB    //素材库已使用容量
          // }
          this.capacityData = {
            hasUse: res.data.chatCapacity.activeCapacity,
            total: res.data.chatCapacity.capacityTotal,
            items: [
              { label: "会话存档", value: res.data.chatCapacity.chatCapacity },
              {
                label: "素材库",
                value: res.data.chatCapacity.materialCapacity,
              },
            ],
            percentage:
              res.data.chatCapacity.percentage > 100
                ? 100
                : res.data.chatCapacity.percentage,
          };
          this.initCheckList = JSON.parse(JSON.stringify(this.checkList));
        } else {
          this.$message.error("获取基础设置失败,请重试！");
        }
      });
    },
    getCapacity() {},
    formatCapacity(percentage) {
      return "";
    },
    handleOpen() {
      let routerUrl = this.$router.resolve({
        path: "/chat/StaffChatSupervise",
      });
      window.open(routerUrl.href, "_black");
    },

    /** 点击触发客户标签同步 */
    synchronization() {
      tagSyncTagApi(localStorage.getItem("Authorization")).then((res) => {
        console.log("res++++", res);
        if (res && res.error && res.error.code == 200) {
          this.$message.success("操作成功");
          this.getBtnStatus();
        }
      });
    },

    /** 获取同步按钮是否可点击的状态 */
    getBtnStatus() {
      checkTimeApi(localStorage.getItem("Authorization")).then((res) => {
        console.log("fsfsfsdfds333333f", res);
        if (res && res.error && res.error.code == 200) {
          console.log("fsfsfsdfsdfdsf");
          /** 校验时间 true 表示在15分钟内不允许再次请求 */
          this.isClick = res.data;
          console.log(" this.isClick +++", this.isClick);
        }
      });
    },

    /** 当被禁止点击时候，进行提示 */
    tipClick() {
      if (this.isClick) {
        Message.closeAll();
        this.$message.warning("15分钟内不允许重复操作");
      }
    },

    /** 点击通知职员弹出职员列表树 */
    getEmployee() {
      this.dialogVisibleTree = true;
    },

    // 成员树的事件
    clickSubmitTree(val) {
      console.log("sfsffsdfsfs", JSON.stringify(val.currentMember));
      this.searchMenNames = [];
      this.currentSelectMember = JSON.parse(JSON.stringify(val.currentMember)); // 所有节点的集合
      this.dialogVisibleTree = false;
      this.searchMenNames = JSON.parse(JSON.stringify(val.currentIdName)); // 显示名字的集合
      let arr = JSON.parse(JSON.stringify(val.sendArray)); // 去重的选中成员
      this.userList = [];
      arr.forEach((item) => {
        let obj = {
          userId: item.userId,
          userName: item.userName,
        };
        this.userList.push(obj);
      });
      // console.log("sdfssfdsf", arr);
      console.log("sdfssfdsf", JSON.stringify(this.currentSelectMember));
      console.log("sdfssfdsf", this.currentSelectMember);
      // console.log("sdfssfdsf", this.searchMenNames);
      // this.params.userIdList = [];
      // val.sendArray.forEach((item) => {
      //   let obj = {
      //     userId: item.userId,
      //     name: item.userName,
      //     headId: item.id,
      //   };
      //   this.searchMenNames.push(obj);
      //   // this.params.userIdList.push(item.userId)
      // });
      console.log("this.searchMenNames", this.userList);
      if (this.userList && this.userList.length) {
        this.selectedEmployeeNum = `已选 ${this.userList.length}位`;
      } else {
        this.selectedEmployeeNum = "";
      }
      // this.params.pageNum = 1
      // this.pageparm.currentPage = 1
      // 发送请求
      // this.getTableData()
    },
    // 树关闭
    closeTree(val) {
      this.dialogVisibleTree = false;
    },

    /** 点击删除好友预警保存 */
    save() {
      if (this.userList && this.userList.length) {
        this.userList.forEach((item) => {
          if (item) {
            item.deptJson = JSON.stringify(this.searchMenNames);
          }
        });
      }
      const requestParams = {
        userList: this.userList,
        // deptJson:JSON.stringify(this.searchMenNames)
      };
      console.log("fgsgfd", this.userList);
      addStaffApi(localStorage.getItem("Authorization"), requestParams).then(
        (res) => {
          if (res && res.error && res.error.code == 200) {
            this.$message.closeAll();
            this.$message.success("操作成功");
            this.getmMssageStaffList();
          }
        }
      );
    },

    /** 点击删除好友预警取消 */
    cancel() {
      this.selectedEmployeeNum = "";
      this.searchMenNames = [];
      this.currentSelectMember = [];
      this.userList = [];
    },

    /** 点击删除tag触发 */

    tagClose(val) {
      console.log("val+++1111", val);
      this.$nextTick(() => {
        this.$refs.myStaffTree.clickCurrrntFn(val, true);
      });
      // if (this.searchMenNames && this.searchMenNames.length) {
      //   this.searchMenNames = this.searchMenNames.filter((item) => {
      //     return item.userId !== val.userId;
      //   });
      //   this.selectedEmployeeNum = this.searchMenNames.length;
      // } else {
      //   this.selectedEmployeeNum = "";
      // }
      // console.log("dfsfsdfsdfs1",this.currentSelectMember);
      // if (this.currentSelectMember && this.currentSelectMember.length) {
      //   console.log("dfsfsdfsdfs",this.currentSelectMember);
      //   this.currentSelectMember = this.currentSelectMember.filter((item) => {
      //     return item.userId !== val.userId;
      //   });
      // }
    },
    getmMssageStaffList() {
      messageStaffListApi(localStorage.getItem("Authorization")).then(
        async (res) => {
          if (res && res.error && res.error.code == 200) {
            if (res.data && res.data.length) {
              this.selectedEmployeeNum = `已选 ${res.data.length}位`;
              this.searchMenNames = [];
              this.userList = res.data;
              // res.data.forEach((item) => {
              //   this.searchMenNames.push({
              //     name: item.userName,
              //     id: item.userId,
              //   });
              // });
              let userIds = [];
              console.log("res.data++++", JSON.stringify(res.data));
              if (res.data && res.data.length != 0) {
                userIds = res.data.map((v) => {
                  return v.userId;
                });
              }
              await this.getDepartStaff();
              this.currentSelectMember = this.allStaff.filter((v) => {
                return userIds.includes(v.userId) == true;
              });

              console.log("this.currentSelectMember", this.currentSelectMember);
              console.log("ssdfsdfdsfww3", this.treeData);

              console.log("ssdfsdfdsfww32", res.data);
              // const result = await this.filterOrganizationTree(
              //   this.treeData,
              //   res.data
              // );
              // console.log("result", result);
              if (res.data && res.data.length) {
                try {
                  this.searchMenNames = JSON.parse(res.data[0].deptJson);
                } catch (err) {
                  this.searchMenNames = [];
                }
              } else {
                this.searchMenNames = [];
              }

              // this.currentSelectMember = result;
              // this.getRightData(this.currentSelectMember);
              // this.currentSelectMember  =  res.data
            } else {
              this.selectedEmployeeNum = "";
              this.searchMenNames = [];
              this.currentSelectMember = [];
            }
          }
        }
      );
    },

    // aa(data) {
    //   data.forEach((item) => {
    //     if (item.children && item.children.length) {
    //       aa(item.children);
    //     }else{
    //       res.data.forEach((item1)=>{
    //             item1.userId === item.userId
    //       })
    //     }
    //   });
    // },

    //获取所有员工&部门
    async getDepartStaff() {
      let params = {
        mark: 2,
      };
      await getOrganization(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            //  console.log("res.data+++++",res.data);
            // this.$store.dispatch("tagsView/setTree1", res.data);
            this.allStaff = res.data.empList;
            this.treeData = res.data.departEmpTrees;
            console.log("SDsddsgdfgdfdg", JSON.stringify(this.treeData));
          }
        })
        .catch((err) => {});
    },

    //获取右侧列表的数据
    async getRightData(data) {
      this.searchMenNames = [];
      let memberList = data;
      // 先将所有children下的成员和部门放入selectAllValue
      memberList.map((v) => {
        if (v.hasChildren) {
          this.getChildrenNodes(v);
        }
      });
      memberList.map((v) => {
        if (
          this.selectAllValue.indexOf(v.userId ? v.userId : v.departmentId) ===
          -1
        ) {
          this.searchMenNames.push({
            treeId: v.id, //树id
            id: v.userId ? v.userId : v.departmentId,
            name: v.userName ? v.userName : v.departmentName,
            type: v.userId ? "per" : "depart",
          });
        }
      });
      this.searchMenNames = this.getArrSet(this.searchMenNames, "id");
      console.log("FGDFGDFDFGDF", JSON.stringify(this.searchMenNames));
      //  const result =  await this.buildOrganizationTree(this.allStaff,this.searchMenNames)
      // console.log("dfgdfgdgdfgdfgdf", result);
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
        return setArr;
      }, []);
      return arrays;
    },

    /** 根据数节点所有数据和选中的员工数据获取选中的数据 */
    // filterOrganizationTree(fullTree, selectedUsers) {
    //   // 创建选中用户ID的Set
    //   const selectedUserSet = new Set(selectedUsers.map((user) => user.userId));

    //   // 创建部门ID到部门节点的映射
    //   const departmentMap = new Map();
    //   const buildDepartmentMap = (nodes) => {
    //     nodes.forEach((node) => {
    //       if (node.departmentId !== null && node.departmentId !== undefined) {
    //         departmentMap.set(node.departmentId, node);
    //       }
    //       if (node.children) {
    //         buildDepartmentMap(node.children);
    //       }
    //     });
    //   };
    //   buildDepartmentMap(fullTree);

    //   // 创建部门ID到直接成员计数的映射
    //   const departmentUserCount = new Map();
    //   const buildDepartmentUserCount = (nodes) => {
    //     nodes.forEach((node) => {
    //       if (node.hasChildren) {
    //         // 部门节点
    //         const count = (node.children || []).filter(
    //           (child) => !child.hasChildren
    //         ).length;
    //         departmentUserCount.set(node.departmentId, count);
    //         if (node.children) {
    //           buildDepartmentUserCount(node.children);
    //         }
    //       }
    //     });
    //   };
    //   buildDepartmentUserCount(fullTree);

    //   // 创建部门ID到选中成员计数的映射
    //   const selectedUserCount = new Map();
    //   selectedUsers.forEach((user) => {
    //     const deptIds = user.departId
    //       .split(",")
    //       .filter((id) => id && id !== "-1");
    //     deptIds.forEach((deptId) => {
    //       const id = Number(deptId);
    //       selectedUserCount.set(id, (selectedUserCount.get(id) || 0) + 1);
    //     });
    //   });

    //   // 递归处理节点
    //   const processNode = (node) => {
    //     if (!node.hasChildren) {
    //       // 人员节点：直接返回选中状态
    //       return selectedUserSet.has(node.userId) ? [node] : [];
    //     }

    //     // 部门节点：处理子节点
    //     const result = [];
    //     const childResults = [];

    //     if (node.children) {
    //       node.children.forEach((child) => {
    //         const processed = processNode(child);
    //         childResults.push(...processed);
    //       });
    //     }

    //     // 检查是否所有直接成员都被选中
    //     const totalUsers = departmentUserCount.get(node.departmentId) || 0;
    //     const selectedCount = selectedUserCount.get(node.departmentId) || 0;
    //     const allDirectUsersSelected =
    //       totalUsers > 0 && selectedCount >= totalUsers;

    //     if (allDirectUsersSelected) {
    //       // 情况1：所有直接成员都被选中，只返回部门节点
    //       result.push({ ...node, children: [] });
    //     } else {
    //       // 情况2：部分成员被选中，返回选中的子节点
    //       result.push(...childResults);
    //     }

    //     return result;
    //   };

    //   // 处理整个树并返回扁平化结果
    //   return fullTree.flatMap((root) => processNode(root));
    // },

    /** 根据人员获取上级节点 */
    // filterOrganizationTree3(fullTree, selectedUsers) {
    //   // 创建快速查找集合
    //   const selectedUserSet = new Set(selectedUsers.map((u) => u.userId));

    //   // 构建部门ID到部门完整路径的映射
    //   const departmentMap = new Map();
    //   const buildDepartmentMap = (nodes, parentPath = []) => {
    //     nodes.forEach((node) => {
    //       const currentPath = [
    //         ...parentPath,
    //         { id: node.departmentId, name: node.departmentName },
    //       ];

    //       if (node.departmentId !== null) {
    //         departmentMap.set(node.departmentId, currentPath);
    //       }

    //       if (node.children && node.children.length) {
    //         buildDepartmentMap(node.children, currentPath);
    //       }
    //     });
    //   };
    //   buildDepartmentMap(fullTree);

    //   // 处理多部门用户：为每个用户在每个所属部门创建节点
    //   const userNodes = [];
    //   selectedUsers.forEach((user) => {
    //     const deptIds = user.departId
    //       .split(",")
    //       .filter((id) => id && id !== "-1");

    //     deptIds.forEach((deptId) => {
    //       if (deptId && departmentMap.has(Number(deptId))) {
    //         userNodes.push({
    //           id: `${user.userId}-${deptId}`, // 唯一ID
    //           departmentId: -1,
    //           departmentParentId: Number(deptId),
    //           departmentName: null,
    //           hasChildren: false,
    //           userId: user.userId,
    //           userName: user.userName,
    //           children: [],
    //         });
    //       }
    //     });
    //   });

    //   // 递归处理部门节点
    //   const processDepartment = (node) => {
    //     // 收集所有直接子节点
    //     const childDepartments = [];
    //     const childEmployees = [];

    //     // 处理当前部门的直接子节点
    //     (node.children || []).forEach((child) => {
    //       if (child.hasChildren) {
    //         // 部门子节点
    //         const processed = processDepartment(child);
    //         if (processed) {
    //           childDepartments.push(processed);
    //         }
    //       } else if (child.userId) {
    //         // 人员子节点
    //         childEmployees.push(child);
    //       }
    //     });

    //     // 添加多部门用户节点
    //     const additionalUsers = userNodes.filter(
    //       (u) => u.departmentParentId === node.departmentId
    //     );

    //     const allEmployees = [...childEmployees, ...additionalUsers];

    //     // 检查当前部门下的用户是否全部选中
    //     const allUsersSelected =
    //       allEmployees.length > 0 &&
    //       allEmployees.every((e) => selectedUserSet.has(e.userId));

    //     // 处理逻辑
    //     if (childDepartments.length === 0 && allEmployees.length === 0) {
    //       return null;
    //     }

    //     // 情况1：当前部门下所有用户全部选中
    //     if (allUsersSelected) {
    //       return {
    //         ...node,
    //         children: [], // 清空子节点
    //       };
    //     }

    //     // 情况2：部分选中
    //     const selectedChildren = [
    //       ...childDepartments,
    //       ...allEmployees.filter((e) => selectedUserSet.has(e.userId)),
    //     ];

    //     return {
    //       ...node,
    //       children: selectedChildren,
    //     };
    //   };

    //   // 处理根节点
    //   const processedRoot = processDepartment(fullTree[0]);

    //   // 扁平化结果
    //   const result = [];
    //   const flattenTree = (node) => {
    //     if (!node) return;

    //     result.push({
    //       ...node,
    //       children: node.children || [], // 确保children存在
    //     });

    //     (node.children || []).forEach((child) => {
    //       flattenTree(child);
    //     });
    //   };

    //   flattenTree(processedRoot);
    //   return result;
    // },

    /** 处理与人员的关系数据 */
    // filterOrgTree2(orgTree, selectedUsers) {
    //   // 创建快速查找的选中用户集合
    //   const selectedUserSet = new Set(selectedUsers.map((user) => user.userId));

    //   // 创建部门ID到部门的映射
    //   const deptMap = new Map();
    //   const buildDeptMap = (nodes) => {
    //     nodes.forEach((node) => {
    //       // 部门节点
    //       if (node.userId === null || node.userId === undefined) {
    //         deptMap.set(node.departmentId, node);
    //         if (node.children && node.children.length > 0) {
    //           buildDeptMap(node.children);
    //         }
    //       }
    //     });
    //   };
    //   buildDeptMap(orgTree);

    //   // 辅助函数：获取部门下的所有人员ID
    //   const getUserIdsInDept = (deptId) => {
    //     const userIds = [];
    //     const stack = [deptMap.get(deptId)];

    //     while (stack.length > 0) {
    //       const node = stack.pop();
    //       if (node.children) {
    //         node.children.forEach((child) => {
    //           if (child.userId) {
    //             userIds.push(child.userId);
    //           } else {
    //             stack.push(child);
    //           }
    //         });
    //       }
    //     }
    //     return userIds;
    //   };

    //   // 核心递归函数
    //   const processNode = (node) => {
    //     // 人员节点处理
    //     if (node.userId) {
    //       return selectedUserSet.has(node.userId)
    //         ? [{ ...node, children: [] }]
    //         : [];
    //     }

    //     // 部门节点处理
    //     let resultChildren = [];
    //     let allChildrenSelected = true;
    //     let hasChildren = false;

    //     if (node.children) {
    //       hasChildren = true;
    //       node.children.forEach((child) => {
    //         const childResults = processNode(child);
    //         if (childResults.length > 0) {
    //           resultChildren.push(...childResults);
    //         }

    //         // 检查子节点是否全部被选中
    //         if (child.userId) {
    //           if (!selectedUserSet.has(child.userId)) {
    //             allChildrenSelected = false;
    //           }
    //         } else {
    //           if (childResults.length === 0) {
    //             allChildrenSelected = false;
    //           }
    //         }
    //       });
    //     }

    //     // 决定当前部门的返回结果
    //     if (hasChildren && allChildrenSelected) {
    //       // 当前部门下所有子节点全选，返回部门节点
    //       return [{ ...node, children: [] }];
    //     } else if (resultChildren.length > 0) {
    //       // 当前部门部分子节点被选中
    //       return [
    //         { ...node, children: [] }, // 部门节点自身
    //         ...resultChildren, // 选中的人员子节点
    //       ];
    //     }

    //     // 检查当前部门是否包含选中用户（即使没有直接子节点）
    //     const userIds = getUserIdsInDept(node.departmentId);
    //     const hasSelectedUsers = userIds.some((id) => selectedUserSet.has(id));

    //     return hasSelectedUsers ? [{ ...node, children: [] }] : [];
    //   };

    //   // 处理整个树
    //   return orgTree.flatMap((root) => processNode(root));
    // },

    /** 处理部门数据 */
    // filterOrgTree1(orgTree, userList) {
    //   // 创建用户ID映射，用于快速查找接口返回的用户
    //   const userMap = new Map();
    //   userList.forEach((user) => {
    //     userMap.set(user.userId, user);
    //   });

    //   // 递归筛选树节点
    //   function filterNode(node) {
    //     // 如果是人员节点（有userId），检查是否在接口返回的数据中
    //     if (node.userId !== null) {
    //       if (userMap.has(node.userId)) {
    //         // 返回人员节点的克隆（保留children属性）
    //         return { ...node, children: [] };
    //       }
    //       // 不在接口数据中的人员节点，返回null
    //       return null;
    //     }

    //     // 处理部门节点
    //     let hasValidChildren = false;
    //     const filteredChildren = [];

    //     // 递归处理子节点
    //     if (node.children && node.children.length > 0) {
    //       node.children.forEach((child) => {
    //         const filteredChild = filterNode(child);
    //         if (filteredChild !== null) {
    //           filteredChildren.push(filteredChild);
    //           hasValidChildren = true;
    //         }
    //       });
    //     }

    //     // 如果有有效子节点，保留该部门节点
    //     if (hasValidChildren) {
    //       return {
    //         ...node,
    //         children: filteredChildren,
    //       };
    //     }

    //     // 检查当前部门是否包含接口中的用户（通过departId）
    //     const hasUsersInDepartment = [...userMap.values()].some((user) =>
    //       user.departId.includes(`,${node.departmentId},`)
    //     );

    //     // 如果部门包含目标用户但无子节点（扁平化处理）
    //     if (hasUsersInDepartment) {
    //       return {
    //         ...node,
    //         children: [],
    //       };
    //     }

    //     // 其他情况不保留该节点
    //     return null;
    //   }

    //   // 收集所有需要保留的节点（部门和人员）
    //   const resultNodes = [];

    //   // 递归收集所有有效节点
    //   function collectValidNodes(node) {
    //     if (!node) return;

    //     // 添加当前节点到结果集
    //     resultNodes.push(node);

    //     // 递归处理子节点
    //     if (node.children && node.children.length > 0) {
    //       node.children.forEach((child) => {
    //         collectValidNodes(child);
    //       });
    //     }
    //   }

    //   // 处理组织树中的每个根节点
    //   orgTree.forEach((root) => {
    //     const filteredRoot = filterNode(root);
    //     if (filteredRoot !== null) {
    //       collectValidNodes(filteredRoot);
    //     }
    //   });

    //   return resultNodes;
    // },

    /** 处理数据 */
    // buildOrganizationTree(allStaff, checkedList) {
    //   // Step 1: 获取选中人员的userId集合
    //   const checkedUserIds = new Set(checkedList.map((item) => item.id));

    //   // Step 2: 筛选出被选中的员工
    //   const checkedStaff = allStaff.filter((staff) =>
    //     checkedUserIds.has(staff.userId)
    //   );

    //   // Step 3: 统计涉及部门ID
    //   const departmentSet = new Set();
    //   checkedStaff.forEach((staff) => {
    //     if (
    //       staff.departmentParentId !== null &&
    //       staff.departmentParentId !== undefined
    //     ) {
    //       departmentSet.add(staff.departmentParentId);
    //     }
    //   });

    //   // Step 4: 生成部门ID起始值（确保不冲突）
    //   let newDeptNodeId = Math.max(...allStaff.map((s) => s.id), 0) + 1;
    //   const result = [];

    //   // Step 5: 为每个涉及部门创建节点
    //   departmentSet.forEach((deptId) => {
    //     // 收集该部门下的选中员工
    //     const deptStaff = checkedStaff.filter(
    //       (staff) => staff.departmentParentId === deptId
    //     );

    //     if (deptStaff.length > 0) {
    //       // 创建部门节点
    //       const deptNode = {
    //         id: newDeptNodeId++,
    //         departmentId: deptId,
    //         departmentParentId: deptId, // 根据需求调整，示例中为同一值
    //         departmentName: null, // 实际中可补充部门名称
    //         hasChildren: true,
    //         userId: null,
    //         userName: null,
    //         children: deptStaff.map((staff) => ({ ...staff })), // 复制员工数据
    //       };
    //       result.push(deptNode);

    //       // 添加该部门下的员工节点
    //       deptStaff.forEach((staff) => {
    //         result.push({ ...staff });
    //       });
    //     }
    //   });

    //   return result;
    // },
    /** 获取当前系统 */
    // getCheckSystem() {
    //   getCheckSystemApi().then((res) => {
    //     if (res && res.error && res.error.code == 200) {
    //       this.currentSysm = res.data || null;
    //     }
    //   });
    // },
  },

  /** 生命周期 */
  created() {
    // this.getCheckSystem()
    this.getQySetting();
    this.getReports();
    this.getPtypes();
    /** 获取同步按钮是否可以点击状态 */
    this.getBtnStatus();
    this.getmMssageStaffList();
  },
};
</script>

<style lang="scss" scoped>
.enterprise-set-main {
  height: 100%;
  padding: 17px 13px;
  box-sizing: border-box;
  .option-li {
    border-bottom: 1px solid rgba(233, 233, 233, 100);
    font-size: 14px;
    padding: 21px 32px 21px 18px;
    &:first-of-type {
      border-top: 1px solid rgba(233, 233, 233, 100);
    }
    .option-top {
      .options-title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 14px;
        .icon-style {
          width: 20px;
          height: 20px;
          margin-right: 18px;
        }
        .title-text {
          flex: 1;
          color: #404040;
          font-weight: bold;
          .capacity {
            width: 170px;
            padding-left: 32px;
          }
          .capacity-text {
            font-weight: 500;
            color: rgb(127, 127, 127);
          }
          /deep/.el-progress-bar {
            padding-right: 14px;
            .el-progress-bar__outer {
              background-color: rgb(215, 215, 215);
            }
          }
        }
        .option-btn {
          color: #919191;
          cursor: pointer;
          user-select: none;
          .btn-icon {
            transition: all 0.5s;
            color: #101010;
            font-size: 16px;
            margin-left: 10px;
            transform: rotate(0);
          }
          .btn-icon2 {
            transform: rotate(180deg);
          }
        }
        .disable-open {
          cursor: not-allowed !important;
          color: #d9d9d9 !important;
          .btn-icon {
            color: #d9d9d9 !important;
          }
        }
      }
      .options-explain {
        padding: 0 54px 0 38px;
        line-height: 26px;
        .explan-text {
          color: #bfbfbf;
        }
        .tip-icon {
          width: 20px;
          height: 20px;
          vertical-align: middle;
          margin-right: 6px;
        }
        .explan-text-tip {
          color: #f5222d;
        }
        .explain-btn {
          color: #404040;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .notification-column {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 54px 0 38px;
        line-height: 26px;
        .explan-text {
          color: #bfbfbf;
        }
        .tip-icon {
          width: 20px;
          height: 20px;
          vertical-align: middle;
          margin-right: 6px;
        }
        .explan-text-tip {
          color: #f5222d;
        }
        .explain-btn {
          color: #404040;
          text-decoration: underline;
          cursor: pointer;
        }
        .operation-wrap {
          .notification-btn {
            display: flex;
            align-items: center;
          }
        }
      }
    }
    .option-bottom {
      transition: all 0.6s;
      padding: 0 54px 0 36px;
      position: relative;
      .mask {
        position: absolute;
        z-index: 99;
        cursor: not-allowed;
        display: none;
        width: 104px;
        height: 32px;
      }
      .maskShow {
        display: block;
      }
      .synchronization-btn {
        border-radius: 20px;
      }
      .check-item {
        padding: 21px 18px;
        font-size: 14px;
        margin-bottom: 6px;
        border-radius: 6px;
        .check-label-wrap {
          .label-title {
            color: #404040;
            font-weight: bold;
            margin-right: 12px;
          }
          .label-tip {
            color: #bfbfbf;
          }
        }
        &:last-of-type {
          margin-bottom: 32px;
        }
      }
      .is-check {
        background-color: #ebf4ff;
        .label-title {
          color: #1890ff !important;
        }
      }
      .owner-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ebf4ff;
        padding: 10px 24px 10px 18px;
        margin-bottom: 32px;
        border-radius: 6px;
        .label-wrap {
          display: flex;
          align-items: center;
          .owner-name {
            padding: 11px;
            background-color: white;
            margin-left: 14px;
            border-radius: 3px;
            color: #096dd9;
            max-width: 7em;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
        }
        .edit-btn {
          color: #096dd9;
          cursor: pointer;
          user-select: none;
        }
      }
      .btn-wrap {
        display: flex;
        justify-content: flex-end;
        /deep/ .el-button {
          width: 120px;
          height: 40px;
          font-size: 14px;
          border: none;
        }
        /deep/.el-button--primary.is-disabled {
          background-color: #bfbfbf;
          border-color: #bfbfbf;
        }
      }
      .tag-wrap {
        display: flex;
        align-items: center;
        margin-top: 20px;
        width: 100%;
        flex-wrap: wrap;
        .el-tag-class {
          margin-left: 6px;
          margin-top: 6px;
        }
      }
    }
    .option-bottom-open {
      // height: 202px;
      overflow: hidden;
      opacity: 1;
      margin-top: 32px;
    }
    .option-bottom-close {
      height: 0;
      overflow: hidden;
      opacity: 0;
    }
    .option-bottom-open2 {
      height: 134px;
      margin-top: 32px;
      overflow: hidden;
      opacity: 1;
    }
    .option-bottom-open3 {
      height: 80px;
      margin-top: 32px;
      overflow: hidden;
      opacity: 1;
    }
  }
  /deep/.transform-dialog {
    .el-dialog__header {
      padding: 16px;
      .el-dialog__title {
        color: #404040;
        font-size: 14px;
      }
    }
    .el-dialog__body {
      padding: 8px 42px 8px 46px;
      .title {
        color: #404040;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 16px;
      }
      .detail {
        color: #bfbfbf;
        font-size: 14px;
      }
    }
    .el-dialog__footer {
      padding: 18px 36px;
      .el-button {
        font-size: 14px;
        width: 120px;
        height: 40px;
        border-radius: 6px;
      }
      .cancel {
        border: none;
        color: #096dd9;
      }
    }
  }
  .capacity-item {
    color: rgb(127, 127, 127);
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    &-point {
      background-color: rgb(254, 154, 35);
      border-radius: 50%;
      width: 8px;
      height: 8px;
      margin-right: 16px;
    }
    &-label {
      width: 200px;
    }
  }
  .btn-wrap {
    display: flex;
    justify-content: flex-end;
    /deep/ .el-button {
      width: 120px;
      height: 40px;
      font-size: 14px;
      border: none;
    }
    /deep/.el-button--primary.is-disabled {
      background-color: #bfbfbf;
      border-color: #bfbfbf;
    }
  }
}
</style>
